<strong class="ttl-2">
  <span>{{ taglineTop }}</span>
  <span>{{ taglineBottom }}</span>
</strong>
